import { render, staticRenderFns } from "./PersonalComponent.vue?vue&type=template&id=179b9b85&scoped=true&"
import script from "./PersonalComponent.vue?vue&type=script&lang=js&"
export * from "./PersonalComponent.vue?vue&type=script&lang=js&"
import style0 from "./PersonalComponent.vue?vue&type=style&index=0&id=179b9b85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b9b85",
  null
  
)

export default component.exports